import { render } from "./DriverBooks.vue?vue&type=template&id=4b8f9d74"
import script from "./DriverBooks.vue?vue&type=script&lang=js"
export * from "./DriverBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__